import { Prioset } from '@ui/shared/model';

import { ActionState, ActionStateCreator } from '@ui/legacy-lib';
import {
  CLEAR_LATEST_PRIOSET_SAVED,
  PriosetAction,
  UPDATE_PRIOSET,
  UPDATE_PRIOSET_FAIL,
  UPDATE_PRIOSET_SUCCESS
} from './priosets.actions';

export interface PriosetsState {
  loadPropertyActionState: ActionState;
  latestPriosetSaved: Prioset;
}

export const initialState: PriosetsState = {
  loadPropertyActionState: ActionStateCreator.create(),
  latestPriosetSaved: null
};

export function reducer(
  state = initialState,
  action: PriosetAction
): PriosetsState {
  switch (action.type) {
    case UPDATE_PRIOSET: {
      return {
        ...state,
        loadPropertyActionState: ActionStateCreator.onStart(),
        latestPriosetSaved: null
      };
    }

    case UPDATE_PRIOSET_SUCCESS: {
      return {
        ...state,
        loadPropertyActionState: ActionStateCreator.onSuccess(),
        latestPriosetSaved: action.prioset
      };
    }

    case UPDATE_PRIOSET_FAIL: {
      return {
        ...state,
        loadPropertyActionState: ActionStateCreator.onError(
          new Error(action.error)
        ),
        latestPriosetSaved: null
      };
    }

    case CLEAR_LATEST_PRIOSET_SAVED: {
      return {
        ...state,
        latestPriosetSaved: null
      };
    }

    default: {
      return state;
    }
  }
}

export const getLoadPropertyActionState = (state: PriosetsState) =>
  state.loadPropertyActionState;
export const getLatestPriosetSaved = (state: PriosetsState) =>
  state.latestPriosetSaved;
